/**
 * @param  {number} position - Zero-based position
 * @returns {number} One-based position.
 */
function oneBasedPosition(position) {
  return position + 1;
}

module.exports = {
  oneBasedPosition,
};
